import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReportDetailService } from '../services/report-details.service';
import { isShareToken } from '../services/share-token.service';

@Injectable()
export class PublicReportResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private reportDetailSvc: ReportDetailService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = route.params.id;
    if (!isShareToken(token)) {
      this.router.navigate(['/share/expired']);
      return EMPTY;
    }

    return this.reportDetailSvc.getSharedReportDetails(token).pipe(
      catchError(() => {
        this.router.navigate(['/share/expired']);
        return EMPTY;
      })
    );
  }
}
